var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PicList',{attrs:{"category":_vm.category,"subtabs":_vm.subtabs},on:{"showpic":function($event){return _vm.$emit('showPic', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }